import type { ComponentType } from "react";
import type { FormFieldKind } from "@colab/shared";
import type { FieldComponentProps } from "./field-shell";
import { TextField } from "./text-field";
import { LongTextField } from "./long-text-field";
import { EmailField } from "./email-field";
import { NumberField } from "./number-field";
import { DateField } from "./date-field";
import { PartnerLookupField } from "./partner-lookup-field";
import { FileField } from "./file-field";
import { SelectField } from "./select-field";
import { CheckboxField } from "./checkbox-field";
import { SectionHeadingField } from "./section-heading-field";

// kind → renderer map. Validation lives in `buildSubmissionSchema` from
// @colab/shared; default values are inlined in use-form-runtime. So this
// registry is intentionally lighter than the legacy /components/shared/
// forms/fieldRegistry — just the component mapping.

export const FIELD_RENDERERS: Record<
  FormFieldKind,
  ComponentType<FieldComponentProps>
> = {
  text: TextField,
  long_text: LongTextField,
  email: EmailField,
  number: NumberField,
  date: DateField,
  partner_lookup: PartnerLookupField,
  file: FileField,
  select: SelectField,
  checkbox: CheckboxField,
  section_heading: SectionHeadingField,
};
